import GuidedTourStore from './store'
import { guidedTourStore as config } from '../config'

export const store = new GuidedTourStore(config)



// WEBPACK FOOTER //
// ./src/guided-tour/index.js